import { DatabaseService, Deal, DealData, DealRepository } from "../core";
import { DatabaseCollection } from "./config";
import { getGenericRepository } from "./generic-repository";

export function getDealRepository(
  databaseService: DatabaseService,
): DealRepository {
  return getGenericRepository<Deal, DealData>(
    () => DatabaseCollection.DEALS,
    databaseService,
  );
}
